export const reportCategories = [
  {
    name: "Business & Startup Documents",
    subcategories: [
      "Startup Whitepaper",
      "Pitch Deck",
      "Business Plan",
      "Investor Briefing",
      "Executive Summary"
    ]
  },
  {
    name: "Market & Industry Research",
    subcategories: [
      "Competitor Analysis",
      "Trend Forecast",
      "SWOT Analysis",
      "Industry Overview"
    ]
  },
  {
    name: "Marketing & Content Strategy",
    subcategories: [
      "SEO Report",
      "Lead Magnet eBook",
      "Email Sequence",
      "Audience Persona"
    ]
  },
  {
    name: "Client-Facing Reports & Proposals",
    subcategories: [
      "Client Proposal",
      "Sales Pitch",
      "Service Packages",
      "Work Scope Report"
    ]
  },
  {
    name: "Educational & Coaching Materials",
    subcategories: [
      "Mini-Course PDF",
      "Wellness Guide",
      "Learning Plan",
      "Goal Tracker"
    ]
  },
  {
    name: "Product & Tech Comparisons",
    subcategories: [
      "Comparison Chart",
      "Pricing Guide",
      "Tech Breakdown",
      "Buying Guide"
    ]
  },
  {
    name: "Case Studies & Testimonials",
    subcategories: [
      "Success Story",
      "ROI Breakdown",
      "Use Case Summary"
    ]
  },
  {
    name: "Real Estate Reports",
    subcategories: [
      "Neighborhood Report",
      "ROI Analysis",
      "Rental Comparison",
      "Market Trends"
    ]
  },
  {
    name: "Personal Development & Lifestyle",
    subcategories: [
      "Mindset Journal",
      "Nutrition Tracker",
      "Coaching Recap"
    ]
  },
  {
    name: "Plans of Action",
    subcategories: [
      "Health Plan",
      "Healthy Lifestyle",
      "Healthy Foods",
      "Daily Routine",
      "Financial Plan"
    ]
  },
  {
    name: "Create Your Own Category",
    subcategories: [
      "(User-defined)"
    ]
  }
];